import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  role: "main",
  class: "p-fluid p-formgrid p-grid"
}
const _hoisted_4 = { class: "card-list" }
const _hoisted_5 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_6 = { class: "p-field p-col p-col-12 p-md-6 p-lg-3" }
const _hoisted_7 = { class: "card blue" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Tổng số BN khám", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-upload" }, null, -1)
const _hoisted_10 = { class: "value" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "stat" }, null, -1)
const _hoisted_12 = { class: "p-field p-col p-col-12 p-md-6 p-lg-3" }
const _hoisted_13 = { class: "card green" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Tổng số BN cũ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-upload" }, null, -1)
const _hoisted_16 = { class: "value" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "stat" }, null, -1)
const _hoisted_18 = { class: "p-field p-col p-col-12 p-md-6 p-lg-3" }
const _hoisted_19 = { class: "card orange" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Tổng số BN mới", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-download" }, null, -1)
const _hoisted_22 = { class: "value" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "stat" }, null, -1)
const _hoisted_24 = { class: "p-field p-col p-col-12 p-md-6 p-lg-3" }
const _hoisted_25 = { class: "card purple" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Tổng số BN CĐHA", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-download" }, null, -1)
const _hoisted_28 = { class: "value" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "stat" }, null, -1)
const _hoisted_30 = { class: "p-field p-col p-col-12 p-md-6 p-lg-3" }
const _hoisted_31 = { class: "card cryan" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Tổng số BN XN", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-download" }, null, -1)
const _hoisted_34 = { class: "value" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "stat" }, null, -1)
const _hoisted_36 = { class: "p-field p-col p-col-12 p-md-6 p-lg-3" }
const _hoisted_37 = { class: "card noitru" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Tổng VP ngoại trú", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-download" }, null, -1)
const _hoisted_40 = { class: "value" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "stat" }, null, -1)
const _hoisted_42 = { class: "p-field p-col p-col-12 p-md-6 p-lg-3" }
const _hoisted_43 = { class: "card doanhthunhathuoc" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "DT nhà thuốc", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-download" }, null, -1)
const _hoisted_46 = { class: "value" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "stat" }, null, -1)
const _hoisted_48 = { class: "p-field p-col p-col-12 p-md-6 p-lg-3" }
const _hoisted_49 = { class: "card khamsuckhoe" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Số lượt khám SK", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("i", { class: "zmdi zmdi-download" }, null, -1)
const _hoisted_52 = { class: "value" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "stat" }, null, -1)
const _hoisted_54 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_55 = { class: "col-12 p-col-12 p-md-12 p-lg-4" }
const _hoisted_56 = { class: "card" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold","font-size":"15px"} }, "Biểu đồ thống kê lượt khám ", -1)
const _hoisted_58 = { class: "col-12 p-col-12 p-md-12 p-lg-4" }
const _hoisted_59 = { class: "card" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold","font-size":"15px"} }, "Biểu đồ thống kê bệnh nhân cũ", -1)
const _hoisted_61 = { class: "col-12 p-col-12 p-md-12 p-lg-4" }
const _hoisted_62 = { class: "card" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold","font-size":"15px"} }, "Biểu đồ thống kê bệnh nhân mới", -1)
const _hoisted_64 = { class: "col-12 p-col-12 p-md-12 p-lg-6" }
const _hoisted_65 = { class: "card" }
const _hoisted_66 = { class: "col-12 p-col-12 p-md-12 p-lg-6" }
const _hoisted_67 = { class: "card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_panel = _resolveComponent("panel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmPopup),
    _createVNode(_component_Panel, { header: "Thông tin bệnh viện" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("main", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _hoisted_9,
                      _createElementVNode("div", _hoisted_10, _toDisplayString($setup.dashboard.slKham), 1),
                      _hoisted_11
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, _toDisplayString($setup.dashboard.bN_Cu), 1),
                      _hoisted_17
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, _toDisplayString($setup.dashboard.bN_Moi), 1),
                      _hoisted_23
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _hoisted_27,
                      _createElementVNode("div", _hoisted_28, _toDisplayString($setup.dashboard.xquang + $setup.dashboard.sieuAm), 1),
                      _hoisted_29
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, _toDisplayString($setup.dashboard.xetNghiem), 1),
                      _hoisted_35
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _hoisted_39,
                      _createElementVNode("div", _hoisted_40, _toDisplayString($setup.formatMoney($setup.dashboard.vienPhi_NgoaiTru)), 1),
                      _hoisted_41
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _hoisted_45,
                      _createElementVNode("div", _hoisted_46, _toDisplayString($setup.formatMoney($setup.dashboard.doanhthu_nhathuoc)), 1),
                      _hoisted_47
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _hoisted_50,
                      _hoisted_51,
                      _createElementVNode("div", _hoisted_52, _toDisplayString($setup.dashboard.khamSucKhoe), 1),
                      _hoisted_53
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Panel, { header: "Thống kê trong 10 ngày" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _hoisted_57,
              _createVNode(_component_Chart, {
                type: "line",
                data: $setup.lineStylesData,
                options: $setup.basicOptionsLine
              }, null, 8, ["data", "options"])
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _hoisted_60,
              _createVNode(_component_Chart, {
                type: "line",
                data: $setup.lineStylesDataIn,
                options: $setup.basicOptionsLine
              }, null, 8, ["data", "options"])
            ])
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _hoisted_63,
              _createVNode(_component_Chart, {
                type: "line",
                data: $setup.lineStylesDataNew,
                options: $setup.basicOptionsLine
              }, null, 8, ["data", "options"])
            ])
          ]),
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createVNode(_component_panel, { header: "Biểu đồ thanh toán bằng Qrcode" }, {
                default: _withCtx(() => [
                  _createVNode(_component_apexchart, {
                    type: "area",
                    options: $setup.chartOptionsNoiTru,
                    series: $setup.seriesNoiTru
                  }, null, 8, ["options", "series"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              _createVNode(_component_panel, { header: "Biểu đồ viện phí ngoại trú" }, {
                default: _withCtx(() => [
                  _createVNode(_component_apexchart, {
                    type: "area",
                    options: $setup.chartOptions,
                    series: $setup.series
                  }, null, 8, ["options", "series"])
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}